import {Component, Inject, OnInit} from '@angular/core';
import {IDialogView} from '@shared/components/ok-cancel-dialog/ok-cancel-dialog.component';
import {DialogModel} from '@shared/models/dialog.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import {CreateKanbanColumnCommand} from '../../commands/task-manager.command';
import {GetSelectedBoardAction} from '../../store/task-manager.action';
import {TaskManagerConfig} from '../../helpers/task-manager.config';
import {TaskManagerQuery} from '../../helpers/task-manager.query';
import {GraphqlContentScope} from '@shared/models/graphql-content-scope.model';

@Component({
    standalone: false,
    selector: 'particle-add-column-dialog',
  templateUrl: './add-column-dialog.component.html',
  styleUrls: ['./add-column-dialog.component.scss']
})

export class AddColumnDialogComponent implements OnInit, IDialogView {
  data: DialogModel;
  columnName: string;
  inputForm: FormGroup;
  inputFormError: any;
  unsubscribe$ = new Subject<void>();
  constructor(private formBuilder: FormBuilder, @Inject(MAT_DIALOG_DATA) public info: DialogModel) {
    this.inputFormError = {
      value: {required: true, sameColumn: false}
    };
    this.inputForm = this.formBuilder.group({
      value: ['', Validators.required]
    });
    this.inputForm.valueChanges.subscribe(() => {
      this.onFormValuesChanged();
    });
  }

  ngOnInit() {
    this.info.isDisabledOkButton = true;
  }
  onOkClicked() {
    this.data.input.columnName = this.columnName;
    return true;
  }
  onFormValuesChanged () {
    for (const field in this.inputFormError) {
      if (!this.inputFormError.hasOwnProperty(field)) {
        continue;
      }
      const control = this.inputForm.get(field);
      if (control && control.dirty && !control.valid) {
        this.inputFormError.value.required = true;
        this.inputFormError.value.sameColumn = false;
        this.info.isDisabledOkButton = true;
      } else {
        this.columnName = control.value.trim();
        this.inputFormError.value.required = false;
        const columnList = this.info.input.columnList;
        if (columnList.some(c => c.name.toLowerCase() === this.columnName.toLowerCase()) === false) {
          this.info.isDisabledOkButton = false;
          this.inputFormError.value.sameColumn = false;
        } else {
          this.info.isDisabledOkButton = true;
          this.inputFormError.value.sameColumn = true;
        }


      }
    }
  }
}
